export type SelectionLevel = 'region' | 'province' | 'comune';

export interface Selection {
  regions: string[]; // reg_code (string for serialization)
  provinces: string[]; // prov_acr like 'TN'
  comuni: string[]; // istat
}

export const EMPTY_SELECTION: Selection = {
  regions: [],
  provinces: [],
  comuni: [],
};
